module.exports = __webpack_public_path__ + "img/Michel.dd12b7f8.jpg";